import Datepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/dist/locale';
import Error from 'custom-error';

//
var script = {
  name: "CustomDatePicker",
  meta: {
    description: "Componente común de selector de fecha personalizado",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  components: {
    Datepicker,
    Error
  },
  props: {
    placeholder: {
      type: String,
      default: "",
      meta: {
        description: "Texto de referencia para el DatePicker",
        example: "Texto requerido"
      }
    },
    maxDate: {
      type: [Date, String],
      default: null,
      meta: {
        description: "Estable un límite máximo para la fecha ",
        example: "Texto requerido"
      }
    },
    minDate: {
      type: [Date, String],
      default: null,
      meta: {
        description: "Estable un límite mínimo para la fecha ",
        example: "Texto requerido"
      }
    },
    format: {
      type: String,
      default: function () {
        return "dd/MMM/yyyy";
      },
      meta: {
        description: "Establece el formato de fecha en día, mes y año",
        example: "Texto requerido"
      }
    },
    value: {
      type: [Date, String],
      default: null,
      meta: {
        description: "Parámetro de entrada del DatePicker",
        example: "Texto requerido"
      }
    },
    disabled: {
      type: Boolean,
      default: function () {
        return undefined;
      },
      meta: {
        description: "Estado deshabilitado",
        example: "isDisabled"
      }
    },
    label: {
      type: String,
      default: "",
      meta: {
        description: "Control para mostrar texto",
        example: "Texto requerido"
      }
    },
    required: {
      type: String,
      default: function () {
        return "";
      },
      meta: {
        description: "Estado requerido",
        example: "Texto requerido"
      }
    },
    error: {
      type: String,
      default: "",
      meta: {
        description: "Estado Error",
        example: "Texto requerido"
      }
    },
    customErrorMsg: {
      type: String,
      default: function () {
        return this.error;
      },
      meta: {
        description: "Mensaje de error encontrado",
        example: "Texto requerido"
      }
    },
    right: {
      type: Boolean,
      default: false,
      meta: {
        description: "Posicionamiento a la derecha",
        example: "true"
      }
    },
    classContainer: {
      type: String,
      default: "width-container",
      meta: {
        description: "Agrega el selector de fecha a un elemento específico",
        example: "Texto requerido"
      }
    },
    regularLabel: {
      type: Boolean,
      default: () => false,
      meta: {
        description: "Control para mostrar texto en regular",
        example: "true"
      }
    },
    useUtc: {
      type: Boolean,
      default: () => true
    }
  },

  data() {
    return {
      es: es
    };
  },

  computed: {
    disabledDates() {
      return {
        from: this.maxDate ? new Date(this.maxDate) : null,
        to: this.minDate ? new Date(this.minDate) : null
      };
    },

    isDisabled() {
      const disabled = this.disabled !== undefined && this.disabled !== null && this.disabled !== false;
      return disabled;
    },

    isClearEnabled() {
      return this.isDisabled ? false : true;
    },

    getCalendarIcon() {
      return this.disabled ? "fa fa-calendar" : "fa fa-calendar-day";
    }

  },
  methods: {
    onSelectedDate(e) {
      if (e) {
        e = new Date(e - e.getTimezoneOffset() * -60000);
        this.$emit("onSelectedDate", e);
      } else {
        this.$emit("onSelectedDate", null);
      }
    },

    updateValue(value) {
      if (value) {
        value = new Date(value - value.getTimezoneOffset() * -60000);
        this.$emit("input", value);
      } else {
        this.$emit("input", null);
      }
    },

    cleared() {
      this.$emit("cleared");
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.label ? _c('label', {
    staticClass: "data-label",
    class: {
      regular: _vm.regularLabel
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "custom-datetime-picker-container",
    class: [_vm.classContainer, _vm.error ? 'invalidated' : '']
  }, [_c('i', {
    class: _vm.getCalendarIcon
  }), _vm._v(" "), _c('span', [_c('datepicker', {
    class: 'custom-date',
    attrs: {
      "bootstrap-styling": true,
      "language": _vm.es,
      "full-month-name": true,
      "monday-first": true,
      "calendar-class": {
        'custom-datetime-picker': true,
        right: _vm.right
      },
      "format": _vm.format,
      "placeholder": _vm.placeholder,
      "value": _vm.value,
      "use-utc": _vm.useUtc,
      "disabled-dates": _vm.disabledDates,
      "disabled": _vm.isDisabled,
      "required": _vm.required,
      "clear-button": _vm.isClearEnabled,
      "clear-button-icon": "fa fa-times prevent-close-dialog"
    },
    on: {
      "input": _vm.updateValue,
      "selected": _vm.onSelectedDate,
      "keypress": function ($event) {
        return _vm.$emit('keypress', $event);
      },
      "cleared": _vm.cleared
    }
  }, [[_c('input', {
    attrs: {
      "required": _vm.required
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', _vm.value);
      },
      "keypress": function ($event) {
        return _vm.$emit('keypress', $event);
      }
    }
  })]], 2)], 1)]), _vm._v(" "), _vm.error ? _c('error', {
    attrs: {
      "variant": "no-border",
      "message": _vm.customErrorMsg
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-5373f5fd_0", {
    source: ".input-label{height:19px;text-align:left;font:Bold 16px/21px Lato;letter-spacing:0;color:#11291b;line-height:19px}.input-label.regular{font-weight:400}span.invalid:not(input){color:#e85c5c}.width-container{width:192px!important}.invalidated.custom-datetime-picker-container input[type=text]{background-color:#f7d7da}.custom-datetime-picker-container input[type=text]{background:#fff;padding-left:34px;text-align:left;font:Regular 16px/24px Lato;letter-spacing:0;color:#727272;opacity:1}.custom-datetime-picker-container-grey input[type=text]{background:#f2f2f2;border:1px solid #ced4da;border-radius:4px;height:36px;padding:4px;width:173px;text-align:center;padding-left:27px}.custom-datetime-picker-container i{color:#ff7058;position:absolute;margin-top:11px;margin-left:11px;z-index:10}.custom-datetime-picker-container i.prevent-close-dialog{margin-top:26px}.custom-datetime-picker-container.invalidated i{color:#ff5b5c}.custom-datetime-picker-container span.cell.day{text-align:center;font:Bold 13px/20px Lato;letter-spacing:0;color:#11291b;opacity:1;line-height:35px}.custom-datetime-picker-container span.cell.day.selected{background:#ff7058;color:#fff;border-radius:50%}.custom-datetime-picker-container span.cell.day.disabled{opacity:.3}.custom-datetime-picker-container header{padding:10px;margin-bottom:36px}.custom-datetime-picker-container header>span.prev{background:#f8f8f8;border-radius:50%;margin-top:-7px;text-indent:unset}.custom-datetime-picker-container header>span.prev:after{border-right:none}.custom-datetime-picker-container header>span.next{background:#f8f8f8;border-radius:50%;margin-top:-7px;text-indent:unset}.custom-datetime-picker-container header>span.next:after{border-left:none}.custom-datetime-picker-container header+div{padding:0 10px 10px 10px;margin-top:1px}.custom-datetime-picker-container .day-header{background:#f8f8f8;font:Bold 13px/20px Lato;letter-spacing:0;color:#11291b;opacity:1;margin-bottom:10px;line-height:35px}.custom-datetime-picker-container .cell{font:Bold 13px/20px Lato;letter-spacing:0;color:#11291b;opacity:1}.custom-datetime-picker-container .cell.selected{font:Bold 13px/35px Lato;color:#11291b;background:#ff7058;color:#fff}.custom-datetime-picker{background:#fff;position:relative;border-radius:5px}.custom-datetime-picker+div{padding:0 10px 10px 10px}.custom-datetime-picker header .prev+span{background:0 0;font:Bold 13px/20px Lato;letter-spacing:0;color:#11291b;opacity:1}.custom-datetime-picker .cell:not(.blank):not(.disabled).day:hover{border:1px solid #ff7058}.custom-datetime-picker .cell:not(.blank):not(.disabled).month:hover{border:1px solid #ff7058}.custom-datetime-picker .cell:not(.blank):not(.disabled).year:hover{border:1px solid #ff7058}.custom-datetime-picker-container input[type=text]:disabled{background:#e9ecef}.right{right:0!important}.custom-datetime-picker-container .input-group>.form-control:not(:last-child){border-bottom-right-radius:.25rem;border-top-right-radius:.25rem}.custom-datetime-picker-container .vdp-datepicker__clear-button{margin-left:0}.custom-datetime-picker-container .vdp-datepicker__clear-button .input-group-text{padding:0;background:#fff;border:none;position:absolute;top:6px;right:32px}.custom-datetime-picker-container .vdp-datepicker__clear-button i:before{font-size:15px;color:#9d9d9d}.custom-date>.input-group>.form-control{border:1px solid rgba(60,60,60,.26)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installCustomDatePicker(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CustomDatePicker', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
